<template>
  <div class="container-fluid">
    <net-pa-card>
      <template v-slot:header>
        <h6 class="text-right"><i class="fas fa-cheque ml-2"></i> خرید سفته الکترونیک</h6>
      </template>
      <template slot="content">
        <div class="row">
          <div v-if="Level == 1" class="col-12">
            <Introduce-signature @introduce_success="succesIntroduce"></Introduce-signature>
          </div>
          <div v-if="Level == 2" class="col-12">
            <create-sign :IntroduceInfo="IntroduceInfo"></create-sign>
          </div>
        </div>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import NetPaCard from '../../Tools/NetPa/NetPaCard.vue'
import CreateSign from './CreateSign.vue'
import IntroduceSignature from './IntroduceSignature.vue'
export default {
  components: { NetPaCard, IntroduceSignature, CreateSign },
  data() {
    return {
      Level: 2,
      IntroduceInfo: {},
    }
  },
  methods: {
    succesIntroduce(data) {
      Level++
      this.IntroduceInfo = data
    },
  },
  created() {},
}
</script>
